import { Model } from './Model';

export class Home extends Model {
  public apiPath = undefined;
  public className = 'home';
}
